// extracted by mini-css-extract-plugin
export default {"additionalSummaryContainer":"AdditionalSummaryContainer_additionalSummaryContainer__O+VK9"};